export const dashboard = {
	CARD: "dashboard/card",
	USER: "dashboard/user",
	SCHEDULE: "dashboard/schedule",
}

export default dashboard
